// third party library

import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import InputError from '@/components/UI/Form/Error';

const HookScale = ({ name, title, range }: { name: string; title: string; range: string[] }) => {
  const {
    setValue,
    formState: { errors },
    register,
    clearErrors,
  } = useFormContext();
  const selectedValue = useWatch({ name: name });
  const handleSelect = (number: string) => {
    <div {...register(name)}></div>;
    setValue(name, number);
    clearErrors(name);
  };
  useEffect(() => {
    register(name);
  }, [name, register]);

  const getErrorMessage = () => {
    const errorPath = name.split('.');
    let errorMessage = '';

    if (errors) {
      let currentError: any = errors;

      for (let i = 0; i < errorPath.length; i++) {
        if (currentError[errorPath[i]]) {
          currentError = currentError[errorPath[i]];
        } else {
          currentError = null;
          break;
        }
      }
      if (currentError) {
        errorMessage = currentError.message;
      }
    }

    return errorMessage;
  };

  return (
    <div>
      <div>
        <h4 className='leading-7 block text-sm font-medium text-neutralColor-medium'>{title}</h4>
      </div>
      <div className='flex gap-3 mt-3'>
        {range?.map((r, index) => {
          return (
            <div
              key={index}
              className={
                r === selectedValue
                  ? 'relative rounded-full w-10 h-10 text-white text-center bg-primaryColor-normal cursor-pointer'
                  : 'relative rounded-full w-10 h-10 border border-gray-300 text-center cursor-pointer'
              }
              onClick={() => handleSelect(r)}
            >
              <div className='absolute top-2 left-4'>{r}</div>
            </div>
          );
        })}
      </div>
      {getErrorMessage() && <InputError>{getErrorMessage()}</InputError>}
    </div>
  );
};

export default HookScale;
